import logo from 'assets/img/logo.png';
import logoQC from 'assets/img/logo_qc.png';

/**
 * Get the appropriate logo based on environment
 * @returns {string} Logo image path
 */
export const getLogo = () => {
  const env = process.env.REACT_APP_ENV;
  return env === 'qc' ? logoQC : logo;
};
